import { useState, useEffect } from 'react';
import { PaymentMethodsApiAdapter } from '../adapters';
import type { Option } from '../adapters';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';

export const usePaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState<Option[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const httpClient = createHttpClient(apiClientWH);
  const paymentMethodsAdapter = new PaymentMethodsApiAdapter(httpClient);

  const loadPaymentMethods = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await paymentMethodsAdapter.getAll();

      // Si no hay datos de la API, usar datos de prueba
      if (data.length === 0) {
        const mockPaymentMethods: Option[] = [
          { id: '1', name: 'Tarjeta de Crédito' },
          { id: '2', name: 'Tarjeta de Débito' },
          { id: '3', name: 'Transferencia Bancaria' },
          { id: '4', name: 'Efectivo' },
          { id: '5', name: 'PayPal' },
        ];
        setPaymentMethods(mockPaymentMethods);
      } else {
        setPaymentMethods(data);
      }
    } catch (err) {
      setError(
        err instanceof Error ? err.message : 'Error al cargar métodos de pago'
      );
      console.error('Error loading payment methods:', err);

      // En caso de error, usar datos de prueba
      const mockPaymentMethods: Option[] = [
        { id: '1', name: 'Tarjeta de Crédito' },
        { id: '2', name: 'Tarjeta de Débito' },
        { id: '3', name: 'Transferencia Bancaria' },
        { id: '4', name: 'Efectivo' },
        { id: '5', name: 'PayPal' },
      ];
      setPaymentMethods(mockPaymentMethods);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPaymentMethods();
  }, []);

  return {
    paymentMethods,
    loading,
    error,
    loadPaymentMethods,
  };
};
